<template>
  <div>
    <el-menu
            :default-active="$route.path"
            router
            active-text-color="#009bac"
    >
      <siderbar-item v-for="route in pmsMenus" :item="route" base-path="/pms" :key="route.code"></siderbar-item>
    </el-menu>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SiderbarItem from './siderbarItem'
  export default {
    name: 'SiderBar',
    components: {
      SiderbarItem
    },
    data() {
      return {
        pmsMenus: []
      }
    },
    computed: {
      ...mapGetters([
        'addRouters'
      ])
    },
    mounted() {
      this.getPmsMenus()
    },
    methods: {
      getPmsMenus: function() {
        const pms = this.addRouters.filter(route => route.group === 2)[0]
        if (typeof pms.children !== 'undefined' && pms.children !== null) {
          this.pmsMenus = pms.children
        }
      }
    }
  }
</script>

<style>

  .el-submenu .el-menu-item {
    height: 35px;
    line-height: 35px;
  }

  .el-menu-item, .el-submenu__title {
    height: 40px;
    line-height: 40px;
  }

</style>